import React, { useState } from 'react'
import data from './credentials.json'
import {Modal, Button, Alert} from 'react-bootstrap'
import classes from './Page1.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/free-regular-svg-icons'

// function validate(cred){
//     if (cred.username===data.username&&cred.password===data.password) {
//       console.log("true man")
//     }
// }
function LoginPage(props) {
  const [cred,setCred]=useState({PD2pZEJMTxqlYZ1R24iq:"",zZFdq6jmnM7iErvcrsXB5GDTDC:""})
  const [attempt,setAttempt]=useState(false)
  const [active,setActive]=useState(false)
  function validate(cred){
    if (cred.PD2pZEJMTxqlYZ1R24iq===data.PD2pZEJMTxqlYZ1R24iq&&cred.zZFdq6jmnM7iErvcrsXB5GDTDC===data.zZFdq6jmnM7iErvcrsXB5GDTDC) {
      // console.log("true man")
      // console.log(props)
      props.validate(true)
      setCred({...cred,PD2pZEJMTxqlYZ1R24iq:"",zZFdq6jmnM7iErvcrsXB5GDTDC:""})
      setAttempt(false)
      setActive(true)
      props.onHide()
      // window.location.href = "/update"
    }
    else{
    setAttempt(true)
    setActive(false)
    props.validate(false)
    }
}
let message=false
if (active) {
  message=<Alert key={1} variant="success">login Successful.</Alert>
}else if (attempt&&!active) {
  message=<Alert key={0} variant="danger">Wrong Id or password.</Alert>
}
else{
  message=false
}

    
    return (
        <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
            Login page
        </Modal.Title>
      </Modal.Header>
      <Modal.Body align="center">
        <FontAwesomeIcon style={{color:"#AAAAAA"}} icon={faUser} size="10x" />
        <br/>
        <br/>
        <p>
            User-Id
        </p>
        <input type="text" value={cred.PD2pZEJMTxqlYZ1R24iq} className={classes.Login} onChange={e=>setCred({...cred,PD2pZEJMTxqlYZ1R24iq: e.target.value})}></input>
        <p>
            Password
        </p>
        <input type="password" value={cred.zZFdq6jmnM7iErvcrsXB5GDTDC} className={classes.Login} onChange={e=>setCred({...cred,zZFdq6jmnM7iErvcrsXB5GDTDC: e.target.value})}></input>
      {message}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
        <Button onClick={()=>{
          // console.log(cred)
          validate(cred)
          }}>Login</Button>
      </Modal.Footer>
    </Modal>
    )
}

export default LoginPage